module.exports = __webpack_public_path__ + "static/media/collapse.8fedf6a0.svg";